module.exports = __webpack_public_path__ + "static/media/faq-icon.392a3bce.svg";